import ListsForSignedInUsersModal from '@/components/modals/ListsForSignedInUsersModal.vue';
import { ModalHelper } from '@/helpers/modal-helper';
import { getVm } from '@/helpers/vm-helper';

export const preventNonSignedInAction = () => {
	const vm = getVm();
	if (!vm.$store.getters['user/isLoggedIn']()) {
		ModalHelper.openModal(
			ListsForSignedInUsersModal,
			{
				closable: true,
				header: vm.$t('WEBAPP_YOUNOWNEEDANACCOUNTFORLISTSHEADER'),
				body: vm.$t('WEBAPP_YOUNOWNEEDANACCOUNTFORLISTSBODY'),
			},
			{ cssClass: 'lists-for-signed-in-users-modal' }
		);

		return true;
	}

	return false;
};
